import React from "react";
import { Link } from 'react-router-dom';

const SuccessMessage = (props) => {

    const { id } = props;

    return (
        <div className="responded-success-msg">
            <h4 className="thanks">
                Спасибо за Ваш отклик!<br />
                Вы получите уведомление в случае выбора Вас претендентом!
            </h4>
            <div className="big-button">
                <Link to={`/makeorder/${id}`}>
                    <button>
                        Вернуться к заказу    
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default SuccessMessage;


// WEBPACK FOOTER //
// ./src/components/Orders/Execute/SuccessMessage.js